<template>
    <div class="downloader">
        <form class="search-container" @submit.prevent="performSearch">
            <label class="sr-only" for="video-url">{{ strings.form.label }}</label>
            <input id="video-url" v-model="searchQuery" class="search-input" type="text" inputmode="url"
                autocomplete="url" autocapitalize="off" spellcheck="false" :placeholder="strings.form.placeholder"
                aria-describedby="url-hint" />
            <button type="submit" class="search-button" :disabled="loading">
                <span v-if="loading" class="button-spinner" aria-hidden="true"></span>
                <span>{{ loading ? strings.form.loading : strings.form.button }}</span>
            </button>
        </form>

        <p id="url-hint" class="hint">{{ strings.form.hint }}</p>

        <p v-if="error" class="search-error" role="alert">{{ error }}</p>

        <div v-if="searchResult" ref="result" class="result" :aria-busy="loading ? 'true' : 'false'">
            <p class="result-status" role="status">
                <template v-if="loading"><span class="status-spinner" aria-hidden="true"></span>{{ strings.ui.statusLoading }}</template>
                <template v-else-if="slowLoad">{{ strings.ui.statusSlowBefore }}<a :href="searchResult" target="_blank"
                        rel="noopener noreferrer">{{ strings.ui.statusOpenTab }}</a>{{ strings.ui.statusSlowAfter }}</template>
            </p>
            <iframe :key="searchId" :src="searchResult" :title="strings.ui.iframeTitle"
                referrerpolicy="no-referrer-when-downgrade" @load="onIframeLoad"></iframe>
            <p class="result-note">{{ strings.ui.noteBefore }}<a :href="searchResult" target="_blank"
                    rel="noopener noreferrer">{{ strings.ui.noteLink }}</a>{{ strings.ui.noteAfter }}</p>
        </div>
    </div>
</template>

<script>
import strings from "./i18n";

export default {
    data() {
        return {
            strings,
            searchQuery: "",
            searchResult: "",
            searchId: 0,
            error: "",
            loading: false,
            slowLoad: false,
            loadTimer: null
        };
    },
    beforeDestroy() {
        this.clearLoadTimer();
    },
    methods: {
        performSearch() {
            this.clearLoadTimer();
            const raw = this.searchQuery.trim();

            if (!raw) {
                this.error = strings.ui.emptyError;
                this.searchResult = "";
                this.loading = false;
                this.slowLoad = false;
                return;
            }

            // Accept links with or without a scheme, but only allow http(s).
            let candidate = raw;
            if (candidate.startsWith("//")) {
                candidate = `https:${candidate}`;
            } else if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(candidate)) {
                candidate = `https://${candidate}`;
            }

            let url;
            try {
                url = new URL(candidate);
            } catch (e) {
                this.error = strings.ui.invalidError;
                this.searchResult = "";
                this.loading = false;
                this.slowLoad = false;
                return;
            }

            if (!["http:", "https:"].includes(url.protocol) || !url.hostname) {
                this.error = strings.ui.protocolError;
                this.searchResult = "";
                this.loading = false;
                this.slowLoad = false;
                return;
            }

            const params = new URLSearchParams({
                url: url.href,
                adUrl: "https://fluffy-machine.com/M6tpPl"
            });

            this.error = "";
            this.slowLoad = false;
            this.loading = true;
            this.searchId += 1;
            this.searchResult = `https://loader.to/api/card/?${params.toString()}`;

            // If the third-party panel is slow, re-enable the button and offer a fallback.
            this.loadTimer = setTimeout(() => {
                this.loading = false;
                this.slowLoad = true;
                this.loadTimer = null;
            }, 15000);

            this.$nextTick(() => {
                if (this.$refs.result && this.$refs.result.scrollIntoView) {
                    this.$refs.result.scrollIntoView({ behavior: "smooth", block: "nearest" });
                }
            });
        },
        onIframeLoad() {
            this.clearLoadTimer();
            this.loading = false;
            this.slowLoad = false;
        },
        clearLoadTimer() {
            if (this.loadTimer) {
                clearTimeout(this.loadTimer);
                this.loadTimer = null;
            }
        }
    }
};
</script>
